"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Removes extraneous slashes in a URL path.
 *
 * @example
 *  deduplicateSlashes('/app///path/to//stuff')
 *  > '/app/path/to/stuff'
 */
var deduplicateSlashes = function (url) { return url.replace(/\/{2,}/g, '/'); };
exports.default = deduplicateSlashes;
